import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

const DevelopmentPlaceholder = ({ title }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ 
        p: 5, 
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh'
      }}>
        <ConstructionIcon sx={{ fontSize: 80, color: '#ff9800', mb: 3 }} />
        <Typography variant="h4" gutterBottom color="text.primary">
          {title}
        </Typography>
        <Typography variant="h6" color="text.secondary">
          功能开发中...
        </Typography>
        <Typography variant="body2" color="text.disabled" sx={{ mt: 2 }}>
          该功能正在开发中，敬请期待
        </Typography>
      </Paper>
    </Box>
  );
};

export default DevelopmentPlaceholder;
